import { PollStatusType } from "@/types/graphql/site.generated";
import type { PollHostType, SitePoll } from "../model/types";

export function pollPercent(
  votes: number | null | undefined,
  votersCount: number | null | undefined,
): number {
  if (!votes || !votersCount) return 0;
  return Math.round((votes / votersCount) * 100);
}

export function correctOptionIds(poll: SitePoll): string[] {
  return poll.options
    .filter((option) => option.isCorrect === true)
    .map((option) => option.id);
}

export function isGuessed(poll: SitePoll): boolean {
  const correct = correctOptionIds(poll);
  const vote = poll.viewerVote ?? [];
  if (correct.length === 0 || vote.length === 0) return false;
  return (
    correct.length === vote.length && correct.every((id) => vote.includes(id))
  );
}

/** У записи статуса нет: закрытым бывает только опрос эфира. */
export function isPollClosed(poll: SitePoll, hostType: PollHostType): boolean {
  return hostType === "STREAM" && poll.status === PollStatusType.ClosedType;
}

/** Сервер отдаёт votersCount только тогда, когда зрителю можно видеть результаты. */
export function areResultsRevealed(poll: SitePoll): boolean {
  return poll.votersCount !== null && poll.votersCount !== undefined;
}
